export class RequestManager {
    constructor() {
        this._requestVerification = null;
    }

    async DoRequest(
        method, // "DELETE" | "GET" | "PATCH" | "POST" | "PUT"
        url,
        params,
        body
    ) {
        const requestVerification = this._getRequestVerification();

        const options = {
            body: body != null ? JSON.stringify(body) : undefined,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                [this._requestVerification.key]: requestVerification.token,
            },
            method: method,
        };

        return await this._doRequest(options, url, params);
    }

    async DoFormDataRequest(
        method, // "DELETE" | "GET" | "PATCH" | "POST" | "PUT"
        url,
        params,
        body
    ) {
        const requestVerification = this._getRequestVerification();

        const options = {
            body: body != null ? body : undefined,
            credentials: 'same-origin',
            headers: {
                [this._requestVerification.key]: requestVerification.token,
            },
            method: method,
        };

        return await this._doRequest(options, url, params);
    }

    async _doRequest(options, url, params) {
        const requestUrl = this._getUrl(url, params);
        try {
            const response = await fetch(requestUrl, options);

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.Message); // TODO - handle error with message provided form backend
            }

            return await response.json();
        } catch (error) {
            throw error;
        }
    }

    _getRequestVerification() {
        if (this._requestVerification == null) {
            const meta = document.querySelector('#request-verification');

            if (meta == null) {
                throw new Error('Request verification meta tag is missing.');
            }

            this._requestVerification = {
                key: meta.name,
                token: meta.content,
            };
        }

        return this._requestVerification;
    }

    _getUrl(url, params) {
        const queryString = this._createQueryString(params);

        return `${url}${queryString}`;
    }

    _createQueryString(params) {
        if (params == null) {
            return '';
        }

        return `?${Object.keys(params)
            .map((key) => {
                const value = params[key];
                return `${key}=${value}`;
            })
            .join('&')}`;
    }
}

const requestManager = new RequestManager();

export default requestManager;
